// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"styles_thumbnail__k1ARr","column":"styles_column__b7NFA","row":"styles_row__cDCKi","reasonTitle":"styles_reasonTitle__uAwbJ"};